export const dataCard = [
  {
    id: 'bebek-buruk-rupa',
    dbaseId: 'Bebek Buruk Rupa',
    title: 'Bebek Buruk Rupa',
    writer: 'Hans Christian Andersen',
    dbCollection: 'bebek_buruk_rupa',
    idIcon: 1,
    img: 'https://firebasestorage.googleapis.com/v0/b/cerita-dongeng-digital.appspot.com/o/thumbnail_homepage%2Fhomepage_bebek_buruk_rupa.png?alt=media&token=32868af7-b01d-4663-ac88-655aae38e0fe'
  },
  {
    id: 'kelinci-dan-kura-kura',
    dbaseId: 'Kelinci dan Kura-Kura',
    title: 'Kelinci dan Kura Kura',
    writer: 'Aesop',
    dbCollection: 'kelinci_kura',
    idIcon: 2,
    img: 'https://firebasestorage.googleapis.com/v0/b/cerita-dongeng-digital.appspot.com/o/thumbnail_homepage%2Fhomepage_kelinci_kura.png?alt=media&token=7feb26dc-3f0b-45ae-b17b-c3b55e51c0c3'
  },
  {
    id: 'kancil-dan-harimau',
    dbaseId: 'Kancil dan Harimau',
    title: 'Kancil dan Harimau',
    writer: 'Dhanny Larito',
    dbCollection: 'kancil_harimau',
    idIcon: 3,
    img: 'https://firebasestorage.googleapis.com/v0/b/cerita-dongeng-digital.appspot.com/o/thumbnail_homepage%2Fhomepage_kancil_harimau.png?alt=media&token=398dc282-a9e6-4252-8ee0-6ac8173549ab'
  },
  {
    id: 'kancil-dan-buaya',
    dbaseId: 'Kancil dan Buaya',
    title: 'Kancil dan Buaya',
    writer: 'Kathy Morris, John Morris',
    dbCollection: 'kancil_buaya',
    idIcon: 4,
    img: 'https://firebasestorage.googleapis.com/v0/b/cerita-dongeng-digital.appspot.com/o/thumbnail_homepage%2Fhomepage_kancil_buaya.png?alt=media&token=4f98435f-38a7-4ec8-9595-1b77124f00ae'
  }
];
